import React from "react";

var extendStatics = Object.setPrototypeOf || {
  __proto__: []
} instanceof Array && function (e, t) {
  e.__proto__ = t;
} || function (e, t) {
  for (var r in t) {
    t.hasOwnProperty(r) && (e[r] = t[r]);
  }
};

function __extends(e, t) {
  function r() {
    this.constructor = e;
  }

  extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
}

var __assign = Object.assign || function (e) {
  for (var t, r = 1, n = arguments.length; n > r; r++) {
    for (var o in t = arguments[r]) {
      Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
  }

  return e;
};

function __rest(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;

    for (n = Object.getOwnPropertySymbols(e); n.length > o; o++) {
      0 > t.indexOf(n[o]) && (r[n[o]] = e[n[o]]);
    }
  }

  return r;
}

var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (e, t) {
  var r, n, o, a, s, i, p, c;
  e.exports = (r = {
    childContextTypes: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = Object.defineProperty, a = Object.getOwnPropertyNames, s = Object.getOwnPropertySymbols, i = Object.getOwnPropertyDescriptor, c = (p = Object.getPrototypeOf) && p(Object), function e(t, u, l) {
    if ("string" != typeof u) {
      if (c) {
        var f = p(u);
        f && f !== c && e(t, f, l);
      }

      var d = a(u);
      s && (d = d.concat(s(u)));

      for (var y = 0; d.length > y; ++y) {
        var m = d[y];

        if (!(r[m] || n[m] || l && l[m])) {
          var v = i(u, m);

          try {
            o(t, m, v);
          } catch (e) {}
        }
      }

      return t;
    }

    return t;
  });
}),
    getDisplayName_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return e.displayName || e.name || ("string" == typeof e && e.length > 0 ? e : "Unknown");
  };
}),
    getDisplayName = unwrapExports(getDisplayName_1),
    values = Object.values,
    keys = Object.keys,
    assign = Object.assign;

function omit(e, t) {
  return keys(t).filter(function (t) {
    return -1 === e.indexOf(t);
  }).reduce(function (e, r) {
    return __assign({}, e, ((n = {})[r] = t[r], n));
    var n;
  }, {});
}

function prop(e, t) {
  return t[e];
}

var isFn = function isFn(e) {
  return !!e && "function" == typeof e;
},
    isValidRenderProp = function isValidRenderProp(e) {
  return React.isValidElement(e) || isFn(e);
};

function adopt(e, t) {
  if (!values(e).some(isValidRenderProp)) throw Error("The render props object mapper just accept valid elements as value");

  var r = keys(e),
      n = function n(e) {
    var t = e.render,
        r = e.children,
        n = __rest(e, ["render", "children"]);

    return t && isFn(t) ? t(n) : r && isFn(r) && r(n);
  };

  n.displayName = "Adopt";
  return r.reduce(function (n, o, a) {
    var s = prop(o, e),
        i = getDisplayName(n),
        p = getDisplayName(s),
        c = a === r.length - 1,
        u = function u(e) {
      var r = e.render,
          a = e.children,
          i = __rest(e, ["render", "children"]);

      return React.createElement(n, __assign({}, i), function (e) {
        var n = omit(keys(i), e),
            p = r && isFn(r) ? r : a,
            u = function u(e) {
          var r,
              a = assign({}, n, ((r = {})[o] = e, r)),
              s = t && isFn(t) && c ? t(a) : a;
          return p && isFn(p) ? p(s) : null;
        };

        return isFn(s) ? React.createElement(s, assign({}, i, e, {
          render: u
        })) : React.cloneElement(s, {}, u);
      });
    };

    return u.displayName = i + "(" + p + ")", isFn(s) ? hoistNonReactStatics(u, s) : u;
  }, n);
}

var Adopt = function (e) {
  function t(t) {
    var r = e.call(this, t) || this;
    return r.Composed = adopt(t.mapper, r.props.mapProps), r;
  }

  return __extends(t, e), t.prototype.render = function () {
    var e = this.props,
        t = __rest(e, ["mapper", "mapProps"]);

    return React.createElement(this.Composed, __assign({}, t));
  }, t;
}(React.Component);

export { adopt, Adopt };